export const LIMIAR_TROCA_ABA = 60;
export const DESLOCAMENTO_MAXIMO_ABA = 48;
export const LIMIAR_VELOCIDADE_ABA = 0.45;
export const DURACAO_SAIDA_ABA = 170;
export const DURACAO_ENTRADA_ABA = 280;
export const FRACAO_ENTRADA_ABA = 0.3;
export const CURVA_ANIMACAO_ABA = 'cubic-bezier(0.2, 0, 0, 1)';
export const SELETOR_IGNORAR_ARRASTE_ABA = 'input, textarea, select, [role="slider"], app-campo-select, app-balao-mensagem, [data-ignorar-arraste-aba]';
